import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import MDIcon from './MDIcon';

const SmartPagination = ({ t, count, currentPage }) => {
  const [page, setPage] = useState(1);

  const nextPage = () => {
    if (page < count) {
      setPage((prevState) => prevState + 1);
    }
  };

  const lastPage = () => {
    if (page > 1) {
      setPage((prevState) => prevState - 1);
    }
  };

  const handleChange = (event) => {
    const value = Number(event.target.value);
    if (value >= 1 && value <= count) {
      setPage(Number(event.target.value));
    }
  };

  useEffect(() => {
    currentPage(page);
  }, [page]);

  return (
    <div className="smart-pagination">
      <button type="button" onClick={lastPage} disabled={page === 1}>
        <MDIcon iconPath="mdiChevronLeft" className="smart-pagination-icon" />
      </button>
      <div className="smart-pagination-view">
        <div>
          <input
            type="number"
            min={1}
            max={count}
            value={page}
            onChange={handleChange}
          />
        </div>
        <div>{t('general.of')}</div>
        <div>{count}</div>
      </div>
      <button type="button" onClick={nextPage} disabled={page === count}>
        <MDIcon iconPath="mdiChevronRight" className="smart-pagination-icon" />
      </button>
    </div>
  );
};

SmartPagination.propTypes = {
  t: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
  currentPage: PropTypes.func.isRequired,
};
export default withTranslation('common')(SmartPagination);
